import React from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { IconLocation } from "../../assets/icons";
function CardComplex({
  itemImgSrc,
  itemUrl,
  itemName,
  itemCity,
  reserveItemCount,
}) {
  return (
    <Link to={itemUrl}>
      <Card className="p-1 p-md-2 rounded-3 text-center box-shadow-sm h-100">
        <Card.Img
          variant="top"
          src={itemImgSrc + "?width=200"}
          className="rounded-3"
        />
        <Card.Body className="px-0 pb-2 pb-md-2 small-svg">
          <h3 className="text-black fw-bold fs-09">{itemName} </h3>
          <div className="d-flex align-items-center justify-content-center pt-2 fs-075">
            <div>{reserveItemCount} تفریح</div>
            <div className="px-1">-</div>
            <div className="">
              <IconLocation fillColor="red" /> {itemCity}
            </div>
          </div>
        </Card.Body>
      </Card>
    </Link>
  );
}
export default CardComplex;
